import { dialogService } from '@ai/common/src/api/services/dialogService';
import { getUserStore } from '@ai/common/src/store/UserStore';
import { Dialog } from '@ai/common/src/types/chat';
import { makeAutoObservable, runInAction } from 'mobx';
import { userService } from '@api/services/userService';
import { authService } from '@ai/common/src/api/services/authService';

class ActiveDialogsStore {
  dialogs: Dialog[] = [];
  isLoading: boolean = false;
  isInited: boolean = false;
  selectedDialog: Dialog | null = null;
  supervisorOnline: boolean = false;
  pendingDialogId: string | null = null;

  setIsLoading = (v: boolean) => (this.isLoading = v);
  setDialogs = (v: Dialog[]) => (this.dialogs = v);
  setIsInited = (v: boolean) => (this.isInited = v);
  setPendingDialogId = (id: string | null) => (this.pendingDialogId = id);

  setSelectedDialog = async (v: Dialog | null) => {
    this.selectedDialog = v;
    if (v?.operator_requested) {
      try {
        await dialogService.clearOperatorRequested(v.id);
        runInAction(() => {
          v.operator_requested = false;
        });
      } catch (error) {
        console.error(error);
      }
    }
  };

  setSupervisorOnline = async (online: boolean) => {
    try {
      await userService.setSupervisorOnline(online);
      runInAction(() => {
        this.supervisorOnline = online;
        const currentUser = getUserStore('platform').currentUser;
        if (currentUser) {
          currentUser.supervisor_online = online;
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  getIsSupervisorOnline = async () => {
    const userStore = getUserStore('platform');

    if (userStore.currentUser?.supervisor_online === undefined) {
      const userRes = await authService.getCurrent();
      userStore.updateCurrentUser(userRes.data);
    }

    const isOnline = !!userStore.currentUser?.supervisor_online;
    runInAction(() => {
      this.supervisorOnline = isOnline;
    });
    return isOnline;
  };

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  loadDialogsAndExperts = async () => {
    try {
      this.setIsLoading(true);
      const { data } = await dialogService.getActiveDialogs();
      this.setDialogs(data);
      if (!data.find((d) => d.id === this.selectedDialog?.id)) {
        this.setSelectedDialog(null);
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.setIsLoading(false);
      this.setIsInited(true);
    }
  };
}

export const activeDialogsStore = new ActiveDialogsStore();
